import React, { useState } from "react";
import NiceModal, { useModal } from "@ebay/nice-modal-react"
import { useForm } from "react-hook-form";
import userAction from "../../actions/userAction";
import { useToastDispatchContext } from '/src/layouts/toast/context/toastContext';
//import formData from "/src/utils/formData";
import accountService from "../../services/accountService";
import Modal from "/src/components/modal/Modal";
import useModalHelper from "/src/components/modal/hooks/useModalHelper";
import Form from "/src/components/form/Form";
import ButtonAction from "../../../../components/UI/Button/Button";
import Field from '/src/components/UI/Field/Field';
import TextInput from '/src/components/UI/TextField/TextInput';
import "/src/assets/css/polices.css";
import "./ChangePasswordModal.css"
import storage from "/src/utils/storage";
const ChangePasswordModal = NiceModal.create(() => {
    const modal = useModal();

    const { onClose } = useModalHelper(modal);
    const { register, handleSubmit, watch, formState: { errors }, formState } = useForm({
        mode: "onChange",
        defaultValues: "",
    });
    const toast = useToastDispatchContext();
    const [passwordIsValid, setPasswordIsValid] = useState(false);
    const { checkPasswordAvailability } = accountService;
    const onSubmit = async (data) => {
        const formData = new FormData(); // form data plus securise pour les passwords
        // Ajoutez les données à l'objet FormData en utilisant la méthode append
        for (const key in data) {
            formData.append(key, data[key]);
        }
        const result = await userAction.changePassword(formData);
        console.log(toast);
        if (!result) {
            toast.error('Modification Error', 'Your password is not correct');
            return;
        }

        toast.success('Modification Success', 'Congratulations you have changed your password');
        onClose();
    };

    const onValidate = async (value) => {
        if (value.length < 5) return;
        const [response, error] = await checkPasswordAvailability({ password: encodeURIComponent(value) }); // the function is important to detect fragment identifier (like # in password)
        if (error !== null) {
            console.error(error);
            return false;
        }
        setPasswordIsValid(!response.available)
    }


    return (
        <Modal name="change-password" id={modal.id} onClose={onClose}>
            <div className="leave-container">
                <div className="button-leave" id="close_modal_container" onClick={onClose} >
                    <i id="close_modal" className="fa fa-times" aria-hidden="true"></i>
                </div>
            </div>
            <Form className="changePassword-container" onSubmit={handleSubmit(onSubmit)}>
                <Form.Title>Choose a new password</Form.Title>
                <Form.Body>
                    <div>
                        <Field label="Password" listLabelClassName="field-modal" />
                        <TextInput {...register('old_password', { required: true, onChange: (e) => onValidate(e.target.value) })} style={{ borderColor: watch("old_password")?.length > 0 && passwordIsValid == false ? 'red' : "" }} placeholder="Enter  current password" className={"input_password_modal" + (watch("old_password")?.length > 0 && passwordIsValid == false ? " icon_toggle_password_error" : "")} type="password"></TextInput>
                        <Field label="New Password" listLabelClassName="field-modal" />

                        <TextInput {...register('new_password', { required: true, pattern: /^(?=(?:.*\d){2,})(?=(?:.*[\W_]){2,})[0-9A-Za-z\W_]{16,}$/i})} style={{ borderColor: errors.new_password ? 'red' : "" }} placeholder="Enter your new password" className={"input_password_modal" + (errors.new_password ? " icon_toggle_password_error" : "")} type="password"></TextInput>
                        <span className="error-modal_password"> {errors.new_password && "16 characters, 2 number, 2 special character"}</span>
                    </div>
                </Form.Body>
                <Form.Buttons>
                    <ButtonAction className="validate" label="Save" type="submit" disabled={formState.isValid == true && passwordIsValid == true ? false : true} />
                </Form.Buttons>
            </Form>
        </Modal >
    )
});

export default ChangePasswordModal;